import { http } from "@/plugins/axios";
import { logWithPrefix } from "@/plugins/logging";
import store from "@/store";
import Vue from "vue";
import _ from "lodash";
import commonCode from "@/utils/commonCode";
import utils from "@/plugins/utils";

const log = logWithPrefix(["plugins/api.js"]);
const apis = {};
const finishApi = "isFinish";
const refreshUrl = async (ret) => {
  if (ret.next_url) {//For LAN setup change LAN1 ip
    utils.changeUrl(ret.next_url);
  } else {
    const retWaiting = await http.get(finishApi);
    if (retWaiting) {
      window.location.reload();
    } else {
      ret.url ? utils.changeUrl(ret.url) : utils.changeDomain();
    }
  }
};

// request_running: will record current loop's timestamp
let request_running = 0;
apis.csrftoken = async (flag) => {
  const ret = await http.post("token", { method: flag });
  log("csrftoken", ret);
  if (ret && ret.data && ret.data.ts) {
    store.dispatch("user/setCsrfToken", ret.data.ts);
    return ret.data.ts;
  }
  return null;
};

apis.showWaiting = async (t, ret, isProcessStyle, processClass, isShow) => {
  if (ret.code == commonCode.STATUS_OK && ret.wait) {
    const finish_ts = Math.random();
    request_running = finish_ts;
    const maxWait = ret.wait;
    log("maxWait ", maxWait);
    let count = 0;
    let is_disconnected = false;
    let diffTime = 0;
    let sleep_time = 0;
    let startTime = new Date().getTime() / 1000;//get the timing of starting loop
    while (maxWait > count) {
      if (request_running !== finish_ts) {
        return null;
      }
      store.dispatch("page/setLoadingStyle", [
        isProcessStyle || false,
        Math.floor((count * 100) / maxWait),
        processClass || "",
      ]);
      let sleep_count = count;


      /** To fixed WAN LAN Conflict on Fixed IP bug. */
      if (ret.url && count >= commonCode.PRE_WAIT_STAIC_IP_CONFLICT) {
        refreshUrl(ret);
        return ret;
      }

      const retWaiting = await http.get(finishApi);
      if (retWaiting && retWaiting.code === commonCode.STATUS_OK) {
        if (
          retWaiting.data &&
          retWaiting.data.info &&
          retWaiting.data.info.config_submit_is_finished == 1
        ) {
          ret.code = retWaiting.code;
          store.dispatch("page/setLoadingStyle", [
            isProcessStyle || false,
            100,
            processClass || "",
          ]);
          await utils.sleep(1000);
          if (isShow) {
            store.dispatch("page/setLoading", { value: false, flag: t });
          }
          if (ret.next_url) {//For LAN setup, if LAN1 ip changed, page should redirected to new lan ip after waiting done
            utils.changeUrl(ret.next_url);
          }
          break;
        }
        is_disconnected = false;
      } else {
        is_disconnected = true;
        sleep_count += 20;// get request timeout is 20 seconds.
      }
      diffTime = new Date().getTime() / 1000 - startTime;
      if (is_disconnected) {
        sleep_time = Math.floor(diffTime - count) - 20;//20s is disconnect timeout
      } else {
        sleep_time = Math.floor(diffTime - count);
      }
      count = Math.floor(diffTime);

      if (count < maxWait) {
        for (let c = 0; c < sleep_time * 2; c++) {
          await utils.sleep(900);
          if (request_running !== finish_ts) {
            return null;
          }
          sleep_count++;
          store.dispatch("page/setLoadingStyle", [
            isProcessStyle || false,
            Math.floor((sleep_count * 100) / maxWait),
            processClass || "",
          ]);
          if (sleep_count >= maxWait) {
            store.dispatch("page/setLoadingStyle", [isProcessStyle || false, 100, processClass || ""]);
            count = maxWait;
            break;
          }
        }
      } else {
        break;
      }
      diffTime = new Date().getTime() / 1000 - startTime;
      count = Math.floor(diffTime);

    }
    if (count >= maxWait) {
      if (is_disconnected) {
        store.dispatch("page/setLoadingStyle", [isProcessStyle || false, 100, processClass || ""]);
        refreshUrl(ret);
        return null;
      }
      ret.code = commonCode.STATUS_OK;
      ret.msg = "Timout";
      store.dispatch("page/setLoadingStyle", [isProcessStyle || false, 100, processClass || ""]);
      if (isShow) {
        store.dispatch("page/setLoading", { value: false, flag: t });
      }
    }
  } else if (ret.code == commonCode.STATUS_OK && isShow) {
    store.dispatch("page/setLoadingStyle", [isProcessStyle || false, 100, processClass || ""]);
    store.dispatch("page/setLoading", { value: false, flag: t });
  } else if (ret.code == commonCode.STATUS_FAIL) {
    if (process.env.NODE_ENV === "development" && typeof ret.data == "object") {
      let msg = "Developing debug - Error: \n";
      Object.keys(ret.data).forEach((o, i) => {
        msg += i + 1 + ". " + o + ": " + ret.data[o] + "\n";
      });
      alert(msg);
    }
    store.dispatch("page/setLoading", { value: false, flag: t });
  } else if (ret.code == commonCode.STATUS_UNAUTH) {
    store.dispatch("page/setLoading", { value: false, flag: t });
  }
  return ret;
};

/**
 *
 * @param {String} prefix : api name
 * @param {String} data : Post Data
 * @param {Boolean} isProcessStyle : is Process Style or not, default is false
 * @param {String} processClass: process class name
 * @param {Boolean} showLoading: default is true
 */
apis.post = async (prefix, data, isProcessStyle, processClass, showLoading) => {
  log("[post]", prefix, data);
  const isShow = typeof showLoading == "undefined" ? true : showLoading;
  log("isShow", isShow);
  const t = Math.random();
  if (isShow) {
    store.dispatch("page/setLoadingStyle", [isProcessStyle || false, 0, processClass || ""]);
    store.dispatch("page/setLoading", { value: true, flag: t });
  }

  const ts = await apis.csrftoken(prefix);
  if (!ts) {
    return null;
  }
  request_running = Math.random();
  const ret = await http.post(prefix, data);
  if (!ret) {
    return ret;
  }
  let ret2 = null;
  ret2 = await apis.showWaiting(t, ret, isProcessStyle, processClass, isShow);
  return ret2;
};
apis.get = async (prefix, params, showLoading) => {
  log("[get]", prefix, params);
  const isShow = typeof showLoading == "undefined" ? true : showLoading;
  const data = {
    params: {},
  };
  if (params) {
    _.merge(data.params, params);
  }
  // const ts = await apis.csrftoken(prefix);
  // if (!ts) {
  //   return null;
  // }
  if (isShow) {
    if (prefix != "isFinish") {
      request_running = Math.random();
    }
    store.dispatch("page/setLoadingStyle", [false, 0, ""]);
  }
  const ret = await http.get(prefix, data);
  return ret;
};

apis.upload = async (prefix, data, isProcessStyle, processClass, showLoading) => {
  const isShow = typeof showLoading == "undefined" ? true : showLoading;
  const ts = await apis.csrftoken(prefix);
  if (!ts) {
    return null;
  }
  request_running = Math.random();
  const t = Math.random();
  if (isShow) {
    store.dispatch("page/setLoading", { value: true, flag: t });
    store.dispatch("page/setLoadingStyle", [false, 0, ""]);
  }
  const ret = await http.post(prefix, data, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120 * 1000,
  });
  const ret2 = await apis.showWaiting(t, ret, isProcessStyle, processClass, isShow);
  store.dispatch("page/setLoading", { value: false, flag: t });
  return ret2;
};

apis.download = async (prefix, data) => {
  const t = Math.random();
  store.dispatch("page/setLoading", { value: true, flag: t });
  const ts = await apis.csrftoken(prefix);
  if (!ts) {
    return null;
  }
  const ret = await http.post(prefix, data, {
    responseType: "blob",
    timeout: 120 * 1000,
  });
  if (ret && typeof ret.code == "number") {
    utils.alertBox("Failed to download file");
  } else {
    const blob = new Blob([ret.data]);
    let fileName = ret.headers["content-disposition"].split("filename=")[1];
    if ("download" in document.createElement("a")) {
      const link = document.createElement("a");
      link.download = fileName;
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href);
      document.body.removeChild(link);
    } else {
      navigator.msSaveBlob(blob, fileName);
    }
  }
  store.dispatch("page/setLoading", { value: false, flag: t });
};

Vue.prototype.$api = apis;

export const api = apis;
